const color = {
  grey: '#ccc',
  gray_1: '#C9CACA',
  grey_2: '#949495',
  grey_3: '#595757',
  grey_4: '#f6f6f6',
  orange_sub_bg: '#fff9ed',
  darken_grey: 'darken(grey, 10%)',
  primary_color: '#ED1C24',
  darken_primary: '#BF2329',
  dark_disabled: '#999',
  layout_body_background: 'white',
  layout_header_background: 'white',
  text_color_secondary: 'input_placeholder_color',
  white: 'white',
  black: '#231815',
  container_bg: '#F7F7F7',
  light_bg: '#F6F6F6',
  link_blue: '#008FCC',
};

export default color;
